// extracted by mini-css-extract-plugin
export default {"container":"TaggedStudentDetails__container____13wc","tagStudentNameContainer":"TaggedStudentDetails__tagStudentNameContainer___lFwtu"};